import { useQuery } from 'react-query';
import { getReviewablePhotoCard } from '../apis/getReviewablePhotoCard';

export const useReviewablePhotoCardQuery = () => {
  return useQuery({
    queryKey: ['reviewablePhotoCard'],
    queryFn: async () => {
      const data = await getReviewablePhotoCard();
      return data;
    }
  });
};
